<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <g clip-path="url(#clip0_19972_116898)">
      <path
        d="M22.4348 0H1.56522C1.1501 0 0.751977 0.164906 0.458441 0.458441C0.164906 0.751977 0 1.1501 0 1.56522V22.4348C0 22.8499 0.164906 23.248 0.458441 23.5416C0.751977 23.8351 1.1501 24 1.56522 24H22.4348C22.8499 24 23.248 23.8351 23.5416 23.5416C23.8351 23.248 24 22.8499 24 22.4348V1.56522C24 1.1501 23.8351 0.751977 23.5416 0.458441C23.248 0.164906 22.8499 0 22.4348 0ZM22.9565 22.4348C22.9565 22.5732 22.9016 22.7059 22.8037 22.8037C22.7059 22.9016 22.5732 22.9565 22.4348 22.9565H1.56522C1.42684 22.9565 1.29414 22.9016 1.19629 22.8037C1.09845 22.7059 1.04348 22.5732 1.04348 22.4348V1.56522C1.04348 1.42684 1.09845 1.29414 1.19629 1.19629C1.29414 1.09845 1.42684 1.04348 1.56522 1.04348H22.4348C22.5732 1.04348 22.7059 1.09845 22.8037 1.19629C22.9016 1.29414 22.9565 1.42684 22.9565 1.56522V22.4348ZM17.7391 12C17.7391 12.1384 17.6842 12.2711 17.5863 12.3689C17.4885 12.4668 17.3558 12.5217 17.2174 12.5217H12.5217V17.2174C12.5217 17.3558 12.4668 17.4885 12.3689 17.5863C12.2711 17.6842 12.1384 17.7391 12 17.7391C11.8616 17.7391 11.7289 17.6842 11.6311 17.5863C11.5332 17.4885 11.4783 17.3558 11.4783 17.2174V12.5217H6.78261C6.64423 12.5217 6.51153 12.4668 6.41368 12.3689C6.31584 12.2711 6.26087 12.1384 6.26087 12C6.26087 11.8616 6.31584 11.7289 6.41368 11.6311C6.51153 11.5332 6.64423 11.4783 6.78261 11.4783H11.4783V6.78261C11.4783 6.64423 11.5332 6.51153 11.6311 6.41368C11.7289 6.31584 11.8616 6.26087 12 6.26087C12.1384 6.26087 12.2711 6.31584 12.3689 6.41368C12.4668 6.51153 12.5217 6.64423 12.5217 6.78261V11.4783H17.2174C17.3558 11.4783 17.4885 11.5332 17.5863 11.6311C17.6842 11.7289 17.7391 11.8616 17.7391 12Z"
        fill="#373C44"
      />
    </g>
    <defs>
      <clipPath id="clip0_19972_116898">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'GreySquarePlus24'
};
</script>

<style scoped>

</style>